import template from './issue-tags.html';
import controller from './issue-tags.controller';

const IssueTagsComponent = {
    template,
    controller,
    bindings: {
        allowAdd: '<',
        values: '<',
        selected: '=',
        change: '&'
    },
};

export default IssueTagsComponent;



// WEBPACK FOOTER //
// ../widgets/issue-tags/issue-tags.component.js